import { mapMutations, mapGetters, mapActions } from "vuex";

import enterEmail from "./enter-email-form/index.vue";
import enterPhone from "./enter-phone-form/index.vue";
import registration from "./enter-phone-form/index.vue";

export default {
    name: "enter-form",
    data() {
        return {
            activeEnterRadio: "mobile",
        };
    },
    components: {
        enterEmail,
        enterPhone,
    },
    computed: {
        ...mapGetters({}),
    },
    methods: {
        ...mapActions({}),
        ...mapMutations({
            changePopupRegister: `auth/CHANGE_POPUP_REGISTER`,
            changeRestorePassword: `auth/CHANGE_POPUP_RESTORE_PASSWORD`,
        }),
        changeEmailForm() {
            this.activeEnterRadio = "mobile";
        },
        changePhoneForm() {
            this.activeEnterRadio = "email";
        },
        showRestore() {
            this.changePopupRegister({ show: false, isRedirect: false });
            setTimeout(() => {
                this.changeRestorePassword(true);
            }, 30);
        },
    },
};
